/** @jsx jsx */
import { jsx } from 'theme-ui';
import dividerMobile from '../../images/divider-mobile.png';
import dividerDesktop from '../../images/divider-desktop.png';

export const Title = (props) => (
  <div
    sx={{
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      fontSize: '2.2rem',
      lineHeight: 1.18,
      fontWeight: 'bold',
    }}
    {...props}
  />
);

export const PageSectionDivider = (props) => (
  <div
    sx={{
      color: 'White',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      height: 'auto',
      bg: 'PrimaryDarkBlue',
      backgroundSize: ['1200px', '1280px'],
      backgroundRepeat: 'no-repeat',
      backgroundPosition: ['left top', 'center'],
      backgroundImage: ['none', `url(${dividerDesktop})`],
      px: ['1.4rem', '2.8rem', '6.4rem'],
      pt: ['3.75rem', '4.8rem'],
      pb: ['3.75rem', '4.8rem'],
    }}
    {...props}
  />
);

